var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowIconStreaming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6896_45634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66667C14.8067 6.66667 16 5.47333 16 4V2.66667C16 1.19333 14.8067 0 13.3333 0H2.66667C1.19333 0 0 1.19333 0 2.66667V4C0 5.47333 1.19333 6.66667 2.66667 6.66667V10C2.66667 11.84 4.16 13.3333 6 13.3333H6.66667C6.66667 14.8067 7.86 16 9.33333 16H13.3333C14.8067 16 16 14.8067 16 13.3333V12C16 10.5267 14.8067 9.33333 13.3333 9.33333H9.33333C7.86 9.33333 6.66667 10.5267 6.66667 12H6C4.9 12 4 11.1 4 10V6.66667H13.3333ZM8 12C8 11.2667 8.6 10.6667 9.33333 10.6667H13.3333C14.0667 10.6667 14.6667 11.2667 14.6667 12V13.3333C14.6667 14.0667 14.0667 14.6667 13.3333 14.6667H9.33333C8.6 14.6667 8 14.0667 8 13.3333V12ZM1.33333 4V2.66667C1.33333 1.93333 1.93333 1.33333 2.66667 1.33333H13.3333C14.0667 1.33333 14.6667 1.93333 14.6667 2.66667V4C14.6667 4.73333 14.0667 5.33333 13.3333 5.33333H2.66667C1.93333 5.33333 1.33333 4.73333 1.33333 4Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6896_45634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIconStreaming);
export default __webpack_public_path__ + "static/media/flowIconStreaming.b03f4b3316061ba26e4150c532b8cba6.svg";
export { ForwardRef as ReactComponent };